import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { checkAddPermission, checkDeletePermission, checkEditPermission, fetchCategoryData, fetchCategoryDataFilter, fetchOriginData, fetchOriginDataFilter, filteredCategories, handleAddSingleData, handleAddSingleDataArrival, handleBlurData, handleInputChangeData, handleSelectionChange, handleUpdateSingleData, handleUpdateSingleDataArrival, relatedProductsLoadOptions, resetFormData, setupEditFormData, TableFooter } from '../../Utils/helper';
import { getApi } from '../../Services/apiService';
import DeleteModal from '../../Utils/deleteModal';
import { AsyncPaginate } from 'react-select-async-paginate';
import MultiSelectDropdown from '../../Utils/multiSelectDropdown';

const tagStyles = {
  selectedItems: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
    padding: '5px 0'
  },
  selectedTag: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#f0f0f0',
    borderRadius: '3px',
    padding: '2px 8px',
    margin: '2px',
    fontSize: '14px'
  },
  tagClose: {
    marginLeft: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px'
  }
};

const OrderArrivalMasterDate = () => {
  const [methodType, setMethodType] = useState('');
  const { data, status } = useSelector((state) => state.roleData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('')
  const [orderArrival, setOrderArrival] = useState([])
  const [productCategory, setProductCategory] = useState([]);
  const [productOrigin, setProductOrigin] = useState([]);
  const [shippingMethods, setShippingMethods] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [selectedOriginIds, setSelectedOriginIds] = useState([]);
  const [orderArrivalToEdit, setOrderArrivalToEdit] = useState([]);
  const [selectedCategoryName, setSelectedCategoryName] = useState('');
  const [selectedOriginName, setSelectedOriginName] = useState('');
  const [categoryIsOpen, setIsCategoryOpen] = useState(false);
  const [shippingIsOpen, setIsShippingOpen] = useState(false);
  const [originIsOpen, setOriginIsOpen] = useState(false);
  const [regularDaysOpen, setRegularDaysOpen] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(null)
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDatas, setFilterData] = useState([]);
  const [originOpen, setOriginOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [formData, setFormData] = useState({
    category_name: '',
    origin_name: '',
    variety: '',
    regular_order_days: [],
    order_lead_time_days: '',
    shipping_name: '',
    product_origin_ids: [],
    product_category_ids: [],
    shipping_method_id: '',
  });

  const [formDataCopy, setFormDataCopy] = useState({
    category_name: '',
    origin_name: '',
    variety: '',
    regular_order_days: [],
    order_lead_time_days: '',
    shipping_name: '',
    product_origin_ids: [],
    product_category_ids: [],
    shipping_method_id: ''
  });
  const [touched, setTouched] = useState({
    category: false,
    origin: false,
    variety: false,
    regular_order_Day: false,
    order_lead_time: false,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [orderArrivalToDelete, setOrderArrivalToDelete] = useState(null);

  const dropdownRef = useRef(null);
  useEffect(() => {
    if (searchTerm !== '') {
      // filterData()
      if (categoryOpen) {
        const data = filteredCategories(searchTerm, productCategory);
        setFilterData(data?.length > 0 ? data : []);
      } else if (originOpen) {
        const data = filteredCategories(searchTerm, productOrigin);
        setFilterData(data?.length > 0 ? data : []);
      } else if (shippingIsOpen) {
        const data = filteredCategories(searchTerm, shippingMethods);
        setFilterData(data?.length > 0 ? data : []);
      } else if (originIsOpen) {
        const data = filteredCategories(searchTerm, productOrigin);
        setFilterData(data?.length > 0 ? data : []);
      } else if (categoryIsOpen) {
        const data = filteredCategories(searchTerm, productCategory);
        setFilterData(data?.length > 0 ? data : []);
      }
    }

  }, [searchTerm])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCategoryOpen(false);
        setOriginIsOpen(false)
        setRegularDaysOpen(false)
        setIsShippingOpen(false)
        setCategoryOpen(false)
        setOriginOpen(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  useEffect(() => {
    fetchCategoryData('', setProductCategory);
    fetchOriginData('', setProductOrigin);
    fetchShippingData();
  }, [])

  // const fetchCategoryData = async () => {
  //   const resp = await getApi(`/product-category?per_page=50`);
  //   if (resp?.success === true) {
  //     setProductCategory(resp?.data?.productCategories?.data || []);
  //   }
  // }
  // const fetchOriginData = async () => {
  //   const resp = await getApi(`/product-origin?per_page=50`);
  //   if (resp?.success === true) {
  //     setProductOrigin(resp?.data?.productOrigins?.data || []);
  //   }
  // }

  const fetchShippingData = async (search = '') => {
    try {
      const resp = await getApi(`/shipping-method?per_page=50`);
      if (resp?.success === true) {
        setShippingMethods(resp.data.shippingMethods?.data);
      }
    } catch (error) {
      setError(error.message || 'Failed to fetch shipping details');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOrderArrival = async () => {
    try {
      const queryParams = new URLSearchParams();
      if (Array.isArray(selectedCategoryIds)) {
        selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
      } else if (selectedCategoryIds) {
        queryParams.append('category_ids[]', selectedCategoryIds);
      }
      if (Array.isArray(selectedOriginIds)) {
        selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
      } else if (selectedOriginIds) {
        queryParams.append('origin_ids[]', selectedOriginIds);
      }
      queryParams.append('search', encodeURIComponent(searchQuery))
      queryParams.append('per_page', itemsPerPage)
      queryParams.append('page', currentPage)
      setIsLoading(true);
      setError(null);
      const response = await getApi(`/order-arrival?${queryParams.toString()}`);

      if (response?.success) {
        setOrderArrival(response.data.orderArrivals?.data || []);
        setPageCount(response?.data?.orderArrivals?.last_page)
      } else {
        setError(response?.msg || 'Failed to fetch buyers');
      }
    } catch (error) {
      setError(error.message || 'Failed to fetch buyers');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchOrderArrival();
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery, selectedCategoryIds, selectedOriginIds, itemsPerPage, currentPage]);

  const handleCategoryChange = (e) => {
    const selectedName = e;
    // const selectedName = e.target.value;
    const selectedCategory = productCategory.find(cat => cat.name === selectedName);
    if (selectedCategory) {
      setSelectedCategoryIds(prevIds => {
        // Toggle selection - add if not present, remove if present
        return prevIds.includes(selectedCategory.id)
          ? prevIds.filter(id => id !== selectedCategory.id)
          : [...prevIds, selectedCategory.id];
      });

    }
  };

  const handleOriginChange = (e) => {
    const selectedName = e;
    // const selectedName = e.target.value;
    const selectedOrigin = productOrigin.find(cat => cat.name === selectedName);

    if (selectedOrigin) {
      setSelectedOriginIds(prevIds => {
        // Toggle selection - add if not present, remove if present
        return prevIds.includes(selectedOrigin.id)
          ? prevIds.filter(id => id !== selectedOrigin.id)
          : [...prevIds, selectedOrigin.id];
      });

    }
  };

  useEffect(() => {
    if (orderArrival.length > 0 && orderArrivalToEdit) {
      const currentOrder = orderArrival.find(order => order.id === orderArrivalToEdit.id);
      if (currentOrder?.categories) {
        setFormData(prev => ({
          ...prev,
          product_category_ids: currentOrder.categories.map(cat => cat.id),
          category_names: currentOrder.categories.map(cat => cat.name),
          product_origin_ids: currentOrder.origins.map(cat => cat.id),
          origin_names: currentOrder.origins.map(cat => cat.name),
          shipping_ids: currentOrder.shipping_method_id !== null && currentOrder.shipping_method_id
        }));
      }
    }
  }, [orderArrivalToEdit]);

  const handleCategoryChangeData = (e) => {
    const selectedId = e;
    // const selectedId = e.target.value;
    const selectedCategory = productCategory.find(cat => cat.id == selectedId);

    // setFormData(prev => ({
    //   ...prev,
    //   product_category_id: selectedCategory?.id,
    //   category_name: selectedId // Optional: store name too
    // }));
    setFormData(prev => {
      const currentIds = Array.isArray(prev.product_category_ids)
        ? [...prev.product_category_ids]
        : prev.product_category_ids
          ? [prev.product_category_ids]
          : [];
      const idExists = currentIds.includes(selectedCategory.id);
      const updatedIds = idExists
        ? currentIds.filter(id => id !== selectedCategory.id)
        : [...currentIds, selectedCategory.id];

      return {
        ...prev,
        product_category_ids: updatedIds,
        category_names: updatedIds.map(id =>
          productCategory.find(cat => cat.id === id)?.name
        ).filter(Boolean)
      };
    });
  };

  const handleShippingChangeData = (e) => {
    const selectedId = e;
    const selectedShipping = shippingMethods.find(cat => cat.name == selectedId);
    setFormData(prev => ({
      ...prev,
      shipping_method_id: selectedShipping?.id,
      shipping_name: selectedShipping?.name
    }));
  }

  const handleOriginChangeData = (e) => {
    const selectedId = e;
    // const selectedId = e.target.value;
    const selectedOrigin = productOrigin.find(cat => cat.id == selectedId);
    // const selectedOrigin = productOrigin.find(cat => cat.name == selectedId);

    // setFormData(prev => ({
    //   ...prev,
    //   product_origin_id: selectedOrigin?.id,
    //   origin_name: selectedId // Optional: store name too
    // }));
    setFormData(prev => {
      const currentIds = Array.isArray(prev.product_origin_ids)
        ? [...prev.product_origin_ids]
        : prev.product_origin_ids
          ? [prev.product_origin_ids]
          : [];
      const idExists = currentIds.includes(selectedOrigin.id);
      const updatedIds = idExists
        ? currentIds.filter(id => id !== selectedOrigin.id)
        : [...currentIds, selectedOrigin.id];

      return {
        ...prev,
        product_origin_ids: updatedIds,
        origin_names: updatedIds.map(id =>
          productOrigin.find(cat => cat.id === id)?.name
        ).filter(Boolean)
      };
    });
  };

  const handleRegularDaysChange = (e) => {
    const selectedId = e;
    // const selectedId = e.target.value;

    // setFormData(prev => ({
    //   ...prev,
    //   product_origin_id: selectedOrigin?.id,
    //   origin_name: selectedId // Optional: store name too
    // }));
    setFormData(prev => {
      const currentIds = Array.isArray(prev.regular_order_days)
        ? [...prev.regular_order_days]
        : prev.regular_order_days
          ? [prev.regular_order_days]
          : [];
      const idExists = currentIds.includes(e);
      const updatedIds = idExists
        ? currentIds.filter(id => id !== e)
        : [...currentIds, e];

      return {
        ...prev,
        regular_order_days: updatedIds,
      };
    });
  };

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };


  return (
    <div className="RightSideDiv order-arival-date product-single">
      {showDeleteModal && (
        <DeleteModal setShowDeleteModal={setShowDeleteModal} todelete={orderArrivalToDelete} isLoading={isLoading} setIsLoading={setIsLoading} settoDelete={setOrderArrivalToDelete} fetchData={fetchOrderArrival} route={`/order-arrival/${orderArrivalToDelete?.id}`} type={'order arrival'} />
      )}
      {methodType === '' &&
        <div class="row">
          <div class="col-sm-12">
            <div className='for-pagination'>
              <div className="setting-right setting-right-table table-border-show product-grouping arrival">
                <div class="table-header">
                  <div className="header-left">
                      <MultiSelectDropdown
                        categoryData={productCategory}
                        selectedCategories={selectedCategoryIds}
                        setSelectedCategories={setSelectedCategoryIds}
                        placeholder='Select Categories...'
                        noOptionsMessage='No categories available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchCategoryDataFilter}
                      />
                      <MultiSelectDropdown
                        categoryData={productOrigin}
                        selectedCategories={selectedOriginIds}
                        setSelectedCategories={setSelectedOriginIds}
                        placeholder="Select origin..."
                        noOptionsMessage='No origin available'
                        setCurrentPage={setCurrentPage}
                        fetchOptionsApi={fetchOriginDataFilter}
                      />



                  </div>
                  <div class="table-actions">

                    {checkAddPermission(data?.permissions, 'order_arrival') && (
                      <button class="btn add" onClick={() => setMethodType('add')}>
                        Add <span></span>
                      </button>
                    )}
                  </div>


                </div>

                <div className="permission-table-inner">
                  <table class="custom-table table-striped ">
                    <thead>
                      <tr>
                        <th class="checkbox">Sr.No.
                        </th>
                        <th class="category">Category</th>
                        <th class="origin">Origin</th>
                        <th class="varierty">Variety</th>
                        <th class="order-time">Order lead time</th>
                        <th class="regular-order">regular order day</th>
                        <th class="order-date">Next order date</th>
                        <th class="net-wt">Next ETA</th>
                        <th class="specification">Added By</th>
                        <th class="action">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="10" className="text-center">
                            <div className="spinner-border spinner-border-sm" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      ) : error ? (
                        <tr>
                          <td colSpan="6" className="text-center text-danger">{error}</td>
                        </tr>
                      ) : orderArrival?.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="text-center">No Order Arrival Date found</td>
                        </tr>
                      ) : (
                        orderArrival?.length > 0 && orderArrival?.map((order, index) => (
                          <tr>
                            <td class="checkbox">{index + 1}
                            </td>
                            <td class="category">
                              {order.categories?.map(c => c.name).join(', ')}
                              {/* {(() => {
    const categories = order.categories || order.product_categories || [];
    const names = [];
    
    // Handle various data structures
    if (Array.isArray(categories)) {
      categories.forEach(item => {
        if (item.name) names.push(item.name);
        else if (item.category?.name) names.push(item.category.name);
      });
    } else if (categories.data) {
      categories.data.forEach(item => {
        if (item.name) names.push(item.name);
      });
    }
    
    return names.length ? names.join(', ') : '-';
  })()} */}
                            </td>
                            <td class="Origin">{order.origins?.map(c => c.name).join(', ')}</td>
                            <td class="varierty">{order?.variety}</td>
                            <td class="order-time">{order?.order_lead_time_days}</td>
                            <td class="regular-order">
                              {Array.isArray(order?.regular_order_days)
                                ? order.regular_order_days.join(', ')
                                : order?.regular_order_days}
                            </td>
                            <td class="order-date">{order?.next_order_date}</td>
                            <td class="net-wt">{order?.next_eta}</td>
                            <td class="specification">{order?.added_by}</td>
                            <td class="action action-cs">
                              <div class="dropdown">
                                      {(checkEditPermission(data?.permissions, 'order_arrival') || checkDeletePermission(data?.permissions, 'order_arrival')) && (
                                <button class=" dropdown-toggle action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> <img src={window.getPublicUrl('/assets/images/dots-icon.svg')} alt="" /></button>
                                      )}
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                  <li>
                                    {checkEditPermission(data?.permissions, 'order_arrival') && (
                                      <a href='#' className='dropdown-item' onClick={(e) => { e.preventDefault(); setupEditFormData(order, setFormData, setMethodType, setOrderArrivalToEdit, formDataCopy); }}>
                                        Edit
                                      </a>
                                    )}
                                  </li>
                                  <li>
                                    {checkDeletePermission(data?.permissions, 'order_arrival') && (
                                      <a href="#" className='dropdown-item' onClick={(e) => { e.preventDefault(); setOrderArrivalToDelete(order); setShowDeleteModal(true); }}>Delete</a>
                                    )}
                                  </li>
                                </ul>


                              </div>
                            </td>
                          </tr>
                        )))}
                    </tbody>
                  </table>

                </div>
              </div>
              <div class="table-footer d-flex justify-content-between table-pagination">
                <div className=''>
                  <select name="" id="" className='affter-change-cs page' value={itemsPerPage} onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                  <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                  </select>
                </div>
                <div className=''>
                  <TableFooter
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {/* ------------------------------add new  order start--------------------------- */}
      {/* {methodType === 'add' &&
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right position-relative">
              <h3>Add Order Arrival Date Master </h3>
              <img src="/snf/assets/images/close.svg" className="close" alt="" />
              <div className="setting-inner">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Category<strong>*</strong>
                      </label>
                      <select id="status" class="form-control">
                        <option value="">Select Category</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Origin<strong>*</strong>
                      </label>
                      <select id="status" class="form-control">
                        <option value="">Select Origin</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Variety<strong>*</strong>
                      </label>
                      <select id="status" class="form-control">
                        <option value="">Select Variety</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Order lead time (Days)<strong>*</strong>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter (number of days)"
                      ></input>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Regular order day<strong>*</strong>
                      </label>
                      <select id="status" class="form-control">
                        <option value="">Select Regular Order Day</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-settings">
                <div className="col-sm-12">
                  <div className="d-flex justify-content-end gap-3">
                    <button className="reset">Reset</button>
                    <button className="save" onClick={() => setMethodType('')}>Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      } */}


      {/* ------------------------------Edit new  order start--------------------------- */}

      {(methodType === 'edit' || methodType === 'add') &&
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right position-relative">
              <h3>{methodType === 'add' ? 'Add' : 'Edit'} Order Arrival Date Master </h3>
                <div className="button-settings">
                <div className="col-sm-12">
                  <div className="d-flex justify-content-end gap-3">
                    <button className="reset" onClick={() => resetFormData(setFormData, setError, orderArrivalToEdit, formDataCopy)}>Reset</button>
                    {methodType === 'add' ?
                      <button className="save" onClick={() => handleAddSingleDataArrival(setIsLoading, formData, fetchOrderArrival, setMethodType, formDataCopy, setTouched, setError, '/order-arrival', 'order arrival', setFormData)}>{isLoading ? 'Saving' : 'Save'}</button>
                      :
                      <button className="save" onClick={() => handleUpdateSingleDataArrival(orderArrivalToEdit, setIsLoading, fetchOrderArrival, formData, setMethodType, setFormData, setError, setTouched, `/order-arrival/${orderArrivalToEdit?.id}`, 'order arrival', formDataCopy)}>{isLoading ? 'Saving' : 'Save'}</button>
                    }
                  </div>
                </div>
              </div>
              <img
                src={window.getPublicUrl('/assets/images/close.svg')}
                className="close"
                alt="Close"
                onClick={() => {
                  setMethodType('');
                  resetFormData(setFormData, setError, orderArrivalToEdit, formDataCopy);
                  fetchOrderArrival()
                }}
              />
              <div className="setting-inner">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Category<strong>*</strong>
                      </label>
                      <div className='selctions-option position-relative' >
                        <input type='text' placeholder="category" className="w-100 category affter-change-cs category-select"
                          value={categoryIsOpen ? searchTerm : formData?.category_names?.join(', ')}
                          readOnly={!categoryIsOpen}
                          //  onChange={(e) => {setSearchTerm(e?.target?.value) }} 
                          onChange={categoryIsOpen ? (e) => setSearchTerm(e.target.value) : undefined}
                          onClick={() => { setIsCategoryOpen(!categoryIsOpen); setSearchTerm('') }}
                          onBlur={(e) => handleBlurData(e, setTouched, setError)} />
                        {categoryIsOpen &&
                          <div className='select-option w-100' ref={dropdownRef}>

                            {productCategory && (searchTerm === '' ? productCategory?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? productCategory : filterDatas).map((x, index) => {
                              return (
                                <span key={index}>
                                  <label class="checbox-cs">
                                    <input type="checkbox" onChange={(e) => { e.stopPropagation(); handleCategoryChangeData(x?.id) }} checked={formData?.product_category_ids?.includes(x?.id) || false} />
                                    <span class="checkmark" ></span>
                                  </label>
                                  {x?.name}
                                </span>
                              )
                            })
                              :
                              <span className="no-data-available">No Categories Available</span>
                            }
                          </div>
                        }
                      </div>

                      {/* <div >
                        <MultiSelectDropdown
                          categoryData={productCategory}
                          selectedCategories={selectedCategoryIds}
                          setSelectedCategories={setSelectedCategoryIds}
                          placeholder='Select Categories...'
                          noOptionsMessage='No categories available'
                        />
                      </div> */}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Origin<strong>*</strong>
                      </label>
                      {/* <div >
                                              <MultiSelectDropdown
                                                categoryData={productOrigin}
                                                selectedCategories={selectedOriginIds}
                                                setSelectedCategories={setSelectedOriginIds}
                                                placeholder="Select origin..."
                                                noOptionsMessage='No origin available'
                                              />
                                            </div> */}
                      <div className='selctions-option position-relative'>
                        <input placeholder="origin" class="w-100 category affter-change-cs category-select" value={originIsOpen ? searchTerm : formData?.origin_names?.join(', ')} onChange={(e) => setSearchTerm(e?.target?.value)} onClick={() => { setOriginIsOpen(!originIsOpen); setSearchTerm('') }} />

                        {originIsOpen &&
                          <div className='select-option w-100' ref={dropdownRef}>

                            {(searchTerm === '' ? productOrigin?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? productOrigin : filterDatas).map((x, index) => {
                              return (
                                <span key={index}>
                                  <label class="checbox-cs">
                                    <input type="checkbox" onChange={(e) => handleOriginChangeData(x?.id)} checked={formData?.product_origin_ids.includes(x?.id) ? true : false} />
                                    <span class="checkmark" ></span>
                                  </label>
                                  {x?.name}
                                </span>
                              )
                            })
                              :
                              <span className="no-data-available">No Origin Available</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Variety
                      </label>
                      {/* <select id="status" class="form-control">
                        <option value="">Select Variety</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select> */}
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter variety"
                        name='variety'
                        value={formData?.variety}
                        onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)}
                      // onBlur={(e) => handleBlurData(e, setTouched, setError)}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Order lead time (Days)<strong>*</strong>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter (number of days)"
                        name='order_lead_time_days'
                        value={formData?.order_lead_time_days}
                        onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)}
                        onBlur={(e) => handleBlurData(e, setTouched, setError)}
                      ></input>
                    </div>
                  </div>
                  {/* <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Regular order day<strong>*</strong>
                      </label>
                      <div className='selctions-option position-relative' >
                        <input placeholder="days" class="w-100 category affter-change-cs category-select" value={regularDaysOpen ? searchTerm : ''} onClick={() => setRegularDaysOpen(!regularDaysOpen)} />
                        {!regularDaysOpen && (
                          formData?.regular_order_days?.length > 0 ? (
                            <div style={tagStyles.selectedItems}>
                              {formData?.regular_order_days?.map((day, idx) => (
                                <span key={idx} style={tagStyles.selectedTag}>
                                  {day}
                                  <span
                                    style={tagStyles.tagClose}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setFormData(prev => ({
                                        ...prev,
                                        regular_order_days: prev.regular_order_days.filter(d => d !== day)
                                      }));
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}
                            </div>
                          ) : (
                            <div style={{ padding: '8px', color: '#999' }}>Select Days</div>
                          )
                        )}
                      </div>
                    </div>
                  </div> */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Regular order day<strong>*</strong>
                      </label>
                      <div className='selctions-option position-relative' >
                        <input placeholder="days" class="w-100 category affter-change-cs category-select" value={regularDaysOpen ? searchTerm : (Array.isArray(formData?.regular_order_days) ? formData.regular_order_days.join(', ') : 'Select Days')} onClick={() => setRegularDaysOpen(!regularDaysOpen)} onChange={(e) => setSearchTerm(e.target.value)} />
                        {regularDaysOpen &&
                          <div className='select-option w-100' ref={dropdownRef}>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Mon')} checked={formData?.regular_order_days.includes('Mon') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Mon
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Tue')} checked={formData?.regular_order_days.includes('Tue') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Tue
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Wed')} checked={formData?.regular_order_days.includes('Wed') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Wed
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Thu')} checked={formData?.regular_order_days.includes('Thu') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Thu
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Fri')} checked={formData?.regular_order_days.includes('Fri') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Fri
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Sat')} checked={formData?.regular_order_days.includes('Sat') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Sat
                            </span>
                            <span>
                              <label class="checbox-cs">
                                <input type="checkbox" onChange={(e) => handleRegularDaysChange('Sun')} checked={formData?.regular_order_days.includes('Sun') ? true : false} />
                                <span class="checkmark" ></span>
                              </label>
                              Sun
                            </span>

                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Shipping Method<strong>*</strong>
                      </label>
                      <div className='selctions-option position-relative' >
                        <input placeholder="Shipping method" class="w-100 category affter-change-cs category-select"
                          value={shippingIsOpen ? searchTerm : formData?.shipping_name || 'Select Shipping Method'}
                          onClick={() => { setIsShippingOpen(!shippingIsOpen); setSearchTerm('') }}
                          onBlur={(e) => handleBlurData(e, setTouched, setError)}
                          onChange={(e) => setSearchTerm(e?.target?.value)} />
                        {shippingIsOpen &&
                          <div className='select-option w-100' ref={dropdownRef}>

                            {(searchTerm === '' ? shippingMethods?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? shippingMethods : filterDatas).map((x, index) => {
                              return (
                                <span>
                                  <label class="checbox-cs">
                                    <input type="checkbox" onChange={(e) => { e.stopPropagation(); handleShippingChangeData(x?.name) }} checked={formData?.shipping_method_id?.includes(x.id) || false} />
                                    <span class="checkmark" ></span>
                                  </label>
                                  {x?.name}
                                </span>
                              )
                            })
                              :
                              <span className="no-data-available">No Shipping Method Available</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="button-settings">
                <div className="col-sm-12">
                  <div className="d-flex justify-content-end gap-3">
                    <button className="reset" onClick={() => resetFormData(setFormData, setError, orderArrivalToEdit, formDataCopy)}>Reset</button>
                    {methodType === 'add' ?
                      <button className="save" onClick={() => handleAddSingleDataArrival(setIsLoading, formData, fetchOrderArrival, setMethodType, formDataCopy, setTouched, setError, '/order-arrival', 'order arrival', setFormData)}>{isLoading ? 'Saving' : 'Save'}</button>
                      :
                      <button className="save" onClick={() => handleUpdateSingleDataArrival(orderArrivalToEdit, setIsLoading, fetchOrderArrival, formData, setMethodType, setFormData, setError, setTouched, `/order-arrival/${orderArrivalToEdit?.id}`, 'order arrival', formDataCopy)}>{isLoading ? 'Saving' : 'Save'}</button>
                    }
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default OrderArrivalMasterDate